import React, { PropTypes, Component } from "react"
import InfoModal from "components/generalComponents/infoModal"
import cn from "classnames"
import i18n from "lib/i18n"
import styles from "./ClientProfileSideBar.scss"

const translate = i18n()

const CloseIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        fill="currentColor"
        viewBox="0 -960 960 960"
        width="24"
    >
        <path
            stroke="currentColor"
            d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"
        />
    </svg>
)

export class ClientProfileSideBar extends Component {
    constructor(props) {
        super(props)
        this.state = { isOpenModal: false }
    }

    toggleModal() {
        this.setState({ isOpenModal: !this.state.isOpenModal })
    }

    handleLogout() {
        this.props.onLinkClicked({ id: "logout" })
    }

    render() {
        const { className, onLinkClicked, clientName, activeId, isPhone, isTablet } = this.props
        const { isOpenModal } = this.state
        const items = [
            {
                title: translate("profile_data"),
            },
            {
                id: "files",
                title: translate("profile_files"),
            },
        ]

        return (
            <div className={cn(className, styles.sidebar)}>
                <div className={styles.header}>
                    {clientName}
                    <button
                        onClick={this.toggleModal.bind(this)}
                        className={styles.logout}
                    >
                        <CloseIcon/>
                    </button>
                </div>
                <ul className={styles.menu}>
                    {items.map((item, i) => (
                        <li
                            key={i}
                            className={cn(item.id === activeId && styles.active)}
                            onClick={() => onLinkClicked(item)}
                        >
                            {item.title} {!isPhone && !isTablet && "▶︎"}
                        </li>
                    ))}
                </ul>
                <InfoModal
                    isOpen={isOpenModal}
                    title={translate("are_you_sure_you_want_to_logout")}
                    content={translate("you_will_be_redirected_to_the_login_page")}
                    onCancel={this.toggleModal.bind(this)}
                    onConfirmation={this.handleLogout.bind(this)}
                    cancelLabel={translate("cancel")}
                    confirmationLabel={translate("sidebar_logout")}
                />
            </div>
        )
    }
}
ClientProfileSideBar.propTypes = {
    clientName: PropTypes.string,
    className: PropTypes.string,
    onLinkClicked: PropTypes.func,
    activeId: PropTypes.string,
    isPhone: PropTypes.bool,
    isTablet: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./components/easinsure/client-profile/side-bar/ClientProfileSideBar.jsx